import { MapContainer, TileLayer, useMapEvents, Circle } from "react-leaflet";
import { useState, useEffect } from "react";
import "leaflet/dist/leaflet.css";
import { toast } from "react-toastify";
import { FiMapPin, FiCheck, FiX } from "react-icons/fi";

const SHOP_LOCATION = {
    lat: 12.881111,
    lng: 75.024194
};

const DELIVERY_RADIUS = 5000;

function LocationUpdater({ setLocation, setAddress, setMap }) {

    const map = useMapEvents({
        moveend() {

            const center = map.getCenter();

            const coords = {
                lat: center.lat,
                lng: center.lng
            };

            setLocation(coords);

        }
    });

    useEffect(() => {
        setMap(map);
    }, [map, setMap]);

    return null;
}



export default function LocationPicker({ setLocation, setShowMap }) {


    const [currentLocation, setCurrentLocation] = useState(null);
    const [map, setMap] = useState(null);
    const [locationConfirmed, setLocationConfirmed] = useState(false);

    const [insideDelivery, setInsideDelivery] = useState(true);

    useEffect(() => {

        navigator.geolocation.getCurrentPosition((pos) => {

            const lat = pos.coords.latitude;
            const lng = pos.coords.longitude;

            setCurrentLocation({ lat, lng });

            if (map) {
                map.setView([lat, lng], 16);
            }



        });

    }, [map]);

    useEffect(() => {

        if (!currentLocation) return;

        const distance = getDistance(
            SHOP_LOCATION.lat,
            SHOP_LOCATION.lng,
            currentLocation.lat,
            currentLocation.lng
        );

        setInsideDelivery(distance <= DELIVERY_RADIUS);

    }, [currentLocation]);

    const confirmLocation = () => {

        if (!insideDelivery) {
            toast.error("Sorry, we don't deliver to this location.");
            return;
        }

        setLocation(currentLocation);

        toast.success("Location saved successfully");

        setLocationConfirmed(true);

        setShowMap(false);
    };

    const useCurrentLocation = () => {

        navigator.geolocation.getCurrentPosition((pos) => {

            const lat = pos.coords.latitude;
            const lng = pos.coords.longitude;

            setCurrentLocation({ lat, lng });

            if (map) {
                map.setView([lat, lng], 16);
            }



        });

    };

    return (

        <div>

            <p style={{ fontSize: "14px", marginBottom: "6px" }}>
                Move map to adjust delivery location
            </p>

            <div style={{ position: "relative" }}>

                <MapContainer
                    key="location-map"
                    center={[20.5937, 78.9629]}
                    zoom={5}
                    preferCanvas={true}
                    style={{
                        height: "300px",
                        width: "100%",
                        borderRadius: "10px"
                    }}
                >

                    <TileLayer
                        attribution="&copy; OpenStreetMap"
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />

                    <LocationUpdater
                        setLocation={setCurrentLocation}
                        setMap={setMap}
                    />

                    <Circle
                        center={[SHOP_LOCATION.lat, SHOP_LOCATION.lng]}
                        radius={DELIVERY_RADIUS}
                        pathOptions={{
                            color: "#16a34a",
                            fillColor: "#16a34a",
                            fillOpacity: 0.1
                        }}
                    />

                </MapContainer>

                <img
                    src="/delivery-pin.png"
                    alt="pin"
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: "42px",
                        transform: "translate(-50%, -100%)",
                        zIndex: 1000,
                        pointerEvents: "none"
                    }}
                />

            </div>

            {/* {address && (

                <div style={{ marginTop: "10px", fontSize: "14px" }}>
                    <div style={{ marginTop: "10px", fontSize: "14px", display: "flex", alignItems: "center", gap: "6px" }}>
                        <FiMapPin size={14} />
                        {address}
                    </div>
                </div>

            )} */}

            {!insideDelivery && (

                <p style={{ color: "red", fontSize: "13px" }}>
                    <p style={{ color: "red", fontSize: "13px", display: "flex", alignItems: "center", gap: "6px" }}>
                        <FiX size={14} />
                        Outside delivery area
                    </p>
                </p>

            )}

            <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>



                <button
                    onClick={useCurrentLocation}
                    style={{
                        padding: "8px 10px",            // ↓ reduced
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                        background: "white",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                        fontSize: "13px",               // ↓ smaller text
                        height: "36px"                  // 🔥 fixed height
                    }}
                >
                    <FiMapPin size={14} />
                    Use My Location
                </button>


                <button
                    onClick={confirmLocation}
                    style={{
                        padding: "8px 10px",           // ↓ reduced
                        borderRadius: "8px",
                        border: "none",
                        background: locationConfirmed ? "#22c55e" : "#16a34a",
                        color: "white",
                        cursor: "pointer",
                        fontWeight: "600",
                        fontSize: "13px",
                        height: "36px",                // 🔥 same height
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    {locationConfirmed ? <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <FiCheck size={14} />
                        Location Selected
                    </span> : "Confirm Location"}
                </button>

                {locationConfirmed && (
                    <p style={{ color: "#16a34a", marginTop: "6px", fontSize: "13px" }}>
                        Location saved successfully
                    </p>
                )}

            </div>

        </div>

    );

}

function getDistance(lat1, lon1, lat2, lon2) {

    const R = 6371e3;

    const φ1 = lat1 * Math.PI / 180;
    const φ2 = lat2 * Math.PI / 180;

    const Δφ = (lat2 - lat1) * Math.PI / 180;
    const Δλ = (lon2 - lon1) * Math.PI / 180;

    const a =
        Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) *
        Math.sin(Δλ / 2) * Math.sin(Δλ / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
}